<template>
  <div class="mt-2 flex w-full justify-between">
    <div class="flex flex-col">
      <span v-if="priceDiff > 0" class="text-sm leading-none">
        <span v-text="$t('pages.product_detail_page.price.For')" />
        &nbsp;
        <span class="line-through" v-text="formatPrice(originalPrice)" />
      </span>

      <span
        class="text-2xl font-bold leading-none lg:text-2xl"
        v-text="formatPrice(item.price)"
      />
    </div>

    <div v-if="!!discountPercentage" class="flex items-center">
      <span class="rounded-full bg-highlight px-3 py-2 font-bold text-white"
        >-&nbsp;{{ discountPercentage.toFixed(0) }}%</span
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { usePriceFormatter } from '@/composables/UsePriceFormatter';
import { AlgoliaHit } from '@/types/Algolia/AlgoliaHit';
import { ref } from 'vue';

export type ProductPriceProps = {
  item: AlgoliaHit;
};
const { item } = defineProps<ProductPriceProps>();

const { formatPrice } = usePriceFormatter();

const originalPrice = ref(item.recommended_price || item.price);
const priceDiff = ref(Math.abs(item.price - originalPrice.value));
const discountPercentage = ref(item.discount_percentage);
</script>
